const xsm = 640;
const sm = 760;
const md = 900;
const bax = 1300;
const lg = 1400;
const xl = 1700;
const xxl = 2000;
const breakpoints = {
    xsm,
    sm,
    md,
    bax,
    lg,
    xl,
    xxl
};
export default breakpoints;
